/*
 * Copyright (c) 2023-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, OnInit} from '@angular/core';
import {User} from '../../shared/model/user';
import {UserService} from '../../shared/user.service';
import {BaseComponentDirective} from '../../base/base-component.directive';

@Component({
    selector: 'welcome-component',
    templateUrl: './welcome-component.html',
    styleUrls: ['./welcome-component.scss'],
    standalone: false
})
export class WelcomeComponent extends BaseComponentDirective implements OnInit {
  hasRoles: boolean;
  currentUser: User;

  constructor(protected userService: UserService) {

    super(userService);
  }

  ngOnInit(): void {
    this.currentUser = this.userService.user;
    this.hasRoles = this.currentUser.hasRoles();
  }

}
